import { useLocationStore } from '@global-store/stores/location'

export const formatNumber = (value: number, locale?: string): string => {
  const locationStore = useLocationStore()

  return new Intl.NumberFormat(locale ?? locationStore.currentLocale).format(
    value
  )
}

export const zeroPad = (num: number, length = 2) =>
  String(num).padStart(length, '0')

export const randomId = () => (Math.random() + 1).toString(36).substring(7)
